import React, {useRef, useState, useEffect} from 'react';

export default function ScrollableText({text}) {
    const containerRef = useRef(null);
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);

    const updateScrollButtons = () => {
        const container = containerRef.current;
        if (!container) return;

        setCanScrollUp(container.scrollTop > 0);
        setCanScrollDown(container.scrollTop + container.clientHeight < container.scrollHeight);
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        updateScrollButtons();
        container.addEventListener('scroll', updateScrollButtons);

        return () => container.removeEventListener('scroll', updateScrollButtons);
    }, [text]);

    const scrollToTop = () => {
        if (containerRef.current) containerRef.current.scrollTop = 0;
    };

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        container.scrollTo({
            top: container.scrollHeight,
            behavior: "smooth",
        });

        updateScrollButtons();
    }, [text]);

    const scrollToBottom = () => {
        if (containerRef.current) containerRef.current.scrollTop = containerRef.current.scrollHeight;
    };

    return (
        <div className="relative">
            {canScrollUp && (
                <button
                    onClick={scrollToTop}
                    className="absolute left-1/2 transform -translate-x-1/2 top-2 z-10 bg-gray-200 rounded-full p-1 hover:bg-gray-300"
                >
                    ⬆
                </button>
            )}

            <div
                ref={containerRef}
                className="max-h-96 overflow-y-auto p-2 flex flex-col bg-gray-50 rounded"
            >
                {text && text.length > 0 ? (
                    text.map((text, idx) => (
                        <div
                            key={idx}
                            className={`mb-2 px-3 py-2 rounded-lg max-w-[90%] ${
                                text.user === 'Admin' ? 'bg-blue-100 self-end ml-auto' : 'bg-gray-200 self-start'
                            }`}
                        >
                            <p className="text-sm"><strong>{text.user}:</strong> {text.notes}</p>
                        </div>
                    ))
                ) : (
                    <p className="text-sm text-gray-500">No notes yet.</p>
                )}
            </div>

            {canScrollDown && (
                <button
                    onClick={scrollToBottom}
                    className="absolute left-1/2 transform -translate-x-1/2 bottom-2 z-10 bg-gray-200 rounded-full p-1 hover:bg-gray-300"
                >
                    ⬇
                </button>
            )}
        </div>
    );
}
